import React from "react";
import { IconProps } from "../../types/types";

const TrendingUpIcon:React.FC<IconProps> = ({ size = 22, color = '#009828' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 5.5L16.7659 7.59917L12.2925 12.0725L8.62587 8.40583L1.83337 15.2075L3.12587 16.5L8.62587 11L12.2925 14.6667L18.0675 8.90083L20.1667 11V5.5H14.6667Z"
        fill={color}
      />
    </svg>
  );
};

export default TrendingUpIcon;
